import RestaurantContacts from './RestaurantContacts'
import './RestaurantContacts.css'

export default RestaurantContacts



// WEBPACK FOOTER //
// ./src/components/RestaurantContacts/index.js